import { Component, Input } from '@angular/core';
import { batchAll, CallbackResult, CallbackResultStatus } from '../../../../../../utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../services/customer/customer.service';
import { GuestPassEligibility } from '../../../../../../models/customer';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-bulk-create-guest-passes-modal',
  templateUrl: './bulk-create-guest-passes-modal.component.html',
  styleUrls: ['./bulk-create-guest-passes-modal.component.css']
})
export class BulkCreateGuestPassesModalComponent {
  @Input() customerIds: number[];
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public numPasses = 1;
  public eligibility = GuestPassEligibility.allCustomers;
  public availableStartingAt = '';
  public expiresAt = '';
  public name = '';

  public errorMessage = '';
  public serverError: number = null;

  public loadingSave = false;
  public numberSaved = 0;

  public readonly GuestPassEligibility = GuestPassEligibility;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService,
    public orgConfigService: OrganizationConfigService
  ) {}

  public handleSave() {
    this.errorMessage = '';
    this.loadingSave = true;

    this.numberSaved = 0;
    let successfulCount = 0;

    const customerIdHandler = (customerId: number): Promise<void> => {
      // Stop early if an error message or server error is produced.
      if ((this.errorMessage !== '') || (this.serverError !== null)) {
        return Promise.resolve();
      }

      return this.customerService
        .addGuestPasses(
          customerId,
          this.numPasses,
          this.eligibility,
          this.availableStartingAt,
          this.expiresAt,
          this.name
        )
        .then(() => { successfulCount++; })
        .catch(reason => {
          if (reason.status === 403) {
            this.errorMessage = 'You do not have permission to create guest passes.';
          } else if (reason.status === 400) {
            this.errorMessage = reason.error;
          } else {
            this.serverError = reason.status;
          }
        })
        .finally(() => { this.numberSaved++; });
    };

    batchAll(
      4,
      this.customerIds,
      customerIdHandler
    )
      .then(() => {
        if (this.errorMessage !== '') { return; }

        let successMessage = 'Guest pass';
        if (this.numPasses > 1) {
          successMessage += 'es';
        }
        successMessage += ' successfully created for '
          + successfulCount.toString() + ' customers.';

        this.savedCallback({
          text: successMessage,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .finally(() => { this.loadingSave = false; });
  }

  public getLoadingProgressPercentageStr() {
    return Math.ceil((this.numberSaved / this.customerIds.length) * 100).toString();
  }
}
